export enum TooltipPosition {
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right',
  DYNAMIC = 'dynamic',
}

export const DEFAULT_TOOLTIP_POSITION = TooltipPosition.ABOVE;

export enum TooltipTheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export const DEFAULT_TOOLTIP_THEME = TooltipTheme.DARK;
